import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import "../styles/style.css";
import adnu_logo from "../assets/images/adnu_logo.png";
import rs_logo_f from "../assets/images/roadsense_logo_full.png";

import NavbarLanding from "../components/Navbar/NavbarLanding";

function Index() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      // for loading screen
      return;
    }
    if (user) navigate("/Dashboard");
  }, [user, loading]);
  return (
    <div className="background">
        <NavbarLanding />
        <div className="about_wrapper">
        <div className="about_wrapper_inner">
          <h1>Help</h1>
          <p>If you have any questions, suggestions, or if you're facing any issues, please feel free to reach out to our support team at thesisroad@gmail.com. We're here to ensure your experience with ThesisRoad is seamless and rewarding.</p>
        </div>
        </div>
    </div>
  );
}

export default Index;
